export default __webpack_public_path__ + "static/media/readyscreentitle.a42e21df.png";